module.exports = __webpack_public_path__ + "static/media/YM43_4.e4814e80.jpg";